module.exports = __webpack_public_path__ + "img/LTC-alt.fab61757.svg";